module.exports = __webpack_public_path__ + "static/media/phoneIcon.523142ba.svg";